import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} - ${comic.categoryName}漫画封面`}
          title={`${comic.title}漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2.5 top-2.5 rounded-full px-2.5 py-1 text-[11px] font-semibold text-background-50 ${
            comic.status === "连载中" ? "bg-primary-500" : "bg-secondary-600"
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded-full bg-background-50/90 px-2 py-1 text-[11px] font-semibold text-primary-700 backdrop-blur">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          {comic.rating}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="truncate text-sm font-bold text-foreground-900 md:text-base group-hover:text-primary-600">
          {comic.title}
        </h3>
        <p className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-600 md:text-sm">
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className={`${comic.categoryId === "lianai" ? "ri-heart-3-fill" : "ri-price-tag-3-fill"} text-primary-500`}></i>
            {comic.categoryName}
          </span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i>
            {comic.views}
          </span>
        </p>
      </div>
    </Link>
  );
}